import React from 'react';
import { motion } from 'framer-motion';
import Chart1 from '../../images/family-overview/technical-chart-1.png';
import Chart2 from '../../images/family-overview/technical-chart-2.png';
import Chart3 from '../../images/family-overview/technical-chart-3.png';
import Chart4 from '../../images/family-overview/technical-chart-4.png';

export default function TechnicalDetails() {
  const container = {
    /* ul animation */
    show: {
      transition: {
        delayChildren: 1.2,
        staggerChildren: 0.4,
      },
    },
  };

  const item = {
    /* li animation */
    hidden: { opacity: 0, y: -10 },
    show: { opacity: 1, y: 0, transition: { duration: 1.4 } },
  };
  return (
    <div id="technical-details" className="family-overview-subpage">
      <motion.p
        id="tagline"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        Covering a wide range of hearing loss
      </motion.p>
      <motion.div
        id="chart-wrapper"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.img variants={item} src={Chart1} />
        <motion.img variants={item} src={Chart2} />
        <motion.img variants={item} src={Chart3} />
        <motion.img variants={item} src={Chart4} />
      </motion.div>
    </div>
  );
}
